import {
    Component, OnInit, ViewContainerRef, ChangeDetectorRef, NgZone
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationService } from 'app/common/clientSerivces/notification.service';
import { SplashScreenService } from 'app/common/clientSerivces/splash-screen.service';
import { AppServices } from 'app/servicelayer/app-services';
import { SharedModule } from 'app/common/sharedComponents/shared.module';

@Component({
    selector: 'app-login',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterModule, SharedModule],
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit
{
    loginForm: FormGroup;
    showBtn: boolean = true;
    showPassword: boolean = false;

    constructor(
        private router: Router,
        public notificationService: NotificationService,
        private fb: FormBuilder,
        private containerRef: ViewContainerRef,
        private splashScreenService: SplashScreenService,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private services: AppServices
    )
    {
        this.loginForm = this.fb.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    ngOnInit(): void { }

    get getLoginFormControls() { return this.loginForm.controls; }

    togglePasswordVisibility(): void { this.showPassword = !this.showPassword; }

    login(): void
    {
        this.ngZone.run(() =>
        {
            if (!this.loginForm.valid)
            {
                this.notificationService.showError('Please enter username and password', '');
                return;
            }

            this.showBtn = false;
            this.cdr.markForCheck();
            this.splashScreenService.addDynamicSplashScreen(this.containerRef);

            this.services.authenticationService.login(
                this.loginForm.value.username,
                this.loginForm.value.password
            ).subscribe(
                (response) =>
                {
                    this.ngZone.run(() =>
                    {
                        if (response)
                        {
                            this.splashScreenService.closeSplashScreen();
                            this.showBtn = true;
                            this.cdr.detectChanges();
                            setTimeout(() =>
                            {
                                if (this.router.url.includes('login'))
                                {
                                    this.router.navigate(['/employee/dashboard']);
                                }
                            }, 2000);
                        }
                        else
                        {
                            this.splashScreenService.closeSplashScreen();
                            this.notificationService.showError('Invalid Credentials', '');
                            this.showBtn = true;
                            this.cdr.detectChanges();
                        }
                    });
                },
                () =>
                {
                    this.ngZone.run(() =>
                    {
                        this.splashScreenService.closeSplashScreen();
                        this.notificationService.showError('Login failed. Please try again.', '');
                        this.showBtn = true;
                        this.cdr.detectChanges();
                    });
                }
            );
        });
    }
}
